import React from "react";

const LineBreaker = () => <div className="line-breaker mx-n4 my-5"></div>;

export default LineBreaker;
